import { computed, unref, type MaybeRef } from 'vue'
import { createQuery } from '@/queries'
import {
  getPopularToday,
  type PopularTodayResponse,
} from '@/features/recommendations/api/popularToday'

/**
 * THE TAB IS IN THE KEY. Without it a tab switch would serve the previous
 * tab's cached block — the same silent staleness the may-like shelf guards
 * against, and it looks exactly like a backend that ignores the tab.
 *
 * SO IS THE SIGNED-IN FLAG. The response has three segments anonymous and four
 * signed in, and the fourth is personal: a key that did not change on sign-in
 * would show the anonymous block to a shopper who just logged in, and — worse —
 * one shopper's `for_you` to the next.
 */
export const usePopularTodayQuery = (
  audience: MaybeRef<string>,
  signedIn: MaybeRef<boolean> = false,
) =>
  createQuery<PopularTodayResponse>({
    key: computed(() => [
      'recommendations',
      'popular-today',
      unref(audience),
      unref(signedIn) ? 'me' : 'anon',
    ]),
    fetcher: async () => {
      const response = await getPopularToday(unref(audience))
      return response.data
    },
    staleTime: 10 * 60 * 1000,
  })
